import common from "./common";
import SplashScene from "./scenes/SplashScene";
import GameScene from "./scenes/GameScene";
import DrawingScene from "./scenes/DrawingScene";
import SaveData from "./SaveData";
import ResultsScene from "./scenes/ResultsScene";
import DemoScene from "./scenes/DemoScene";

export default class Application {

    constructor() {
        // Css style for icons
        //const defaultIcon = "url('./assets/images/cursor.png'),auto";

        // Add custom cursor styles
        //common.renderer.plugins.interaction.cursorStyles.default = defaultIcon;
        //common.renderer.plugins.interaction.cursorStyles.hover = defaultIcon;
    }

    init() {
        common.saveData = new SaveData();
        common.saveData.load();

        //P3.audio.mute(true);
        this.showSplashScene();
    }

    showDemoScene() {
        const scene = new DemoScene();
        scene.autoAppear = false;

        this.fadeTransition(function () {
            P3.scene.show(scene);
        }, function () {
            scene.appear();
        }, this);

        return scene;
    }

    showSplashScene() {
        P3.audio.playMusic("music_drawing_loop_a_00");

        const scene = new SplashScene();
        scene.autoAppear = false;

        scene.signals.next.add(function () {
            this.showDrawingScene();
            // this.showGameScene();
        }, this);

        this.fadeTransition(function () {
            P3.scene.show(scene);
        }, function () {
            scene.appear();
        }, this);

        return scene;
    }

    showDrawingScene() {
        this.flagAllTexturesForUnloading();

        const scene = new DrawingScene();
        scene.autoAppear = false;

        scene.signals.next.add(function () {
            this.showGameScene();
        }, this);

        scene.signals.home.add(function () {
            this.showSplashScene();
        }, this);

        scene.signals.previous.add(function () {
            this.showDrawingScene();
        }, this);

        this.fadeTransition(function () {
            P3.scene.show(scene);
        }, function () {
            scene.appear();
        }, this);

        return scene;
    }

    showGameScene() {
        this.flagAllTexturesForUnloading();

        const scene = new GameScene();
        scene.autoAppear = false;

        scene.signals.next.add(function () {
            this.showResultsScene();
        }, this);

        this.fadeTransition(function () {
            P3.scene.show(scene);
        }, function () {
            scene.appear();
        }, this);

        return scene;
    }

    showResultsScene() {
        this.flagAllTexturesForUnloading();

        const scene = new ResultsScene();
        scene.autoAppear = false;

        scene.signals.next.add(function () {
            //  P3.audio.playMusic("music_garage_drawing_loop_00");
            P3.audio.playMusic("music_drawing_loop_a_00");
            this.showDrawingScene();
        }, this);

        scene.signals.previous.add(function () {
            P3.audio.stopMusic();
            this.showGameScene();
        }, this);

        this.fadeTransitionWhite(function () {
            P3.scene.show(scene);
        }, function () {
            scene.appear();
        }, this);

        return scene;
    }

    showTestScene() {
        const scene = new TestScene();
        scene.autoAppear = false;

        scene.signals.next.add(function () {
            //  this.showDrawingScene();
        }, this);

        this.fadeTransition(function () {
            P3.scene.show(scene);
        }, function () {
            scene.appear();
        }, this);

        return scene;
    }

    showSplineEditorScene() {
        const scene = new SplineEditorScene();
        scene.autoAppear = false;

        scene.signals.next.add(function () {
            //  this.showDrawingScene();
        }, this);

        this.fadeTransition(function () {
            P3.scene.show(scene);
        }, function () {
            scene.appear();
        }, this);

        return scene;
    }

    fadeTransition(a, b, scope) {
        scope = scope || window;

        const transition = new P3.FadeTransition(0x0);
        common.transitions.addChild(transition);

        transition.signals.in.add(function () {
            transition.out();
            a && a.call(scope);
        }, this);

        transition.signals.out.add(function () {
            transition.destroy();
            b && b.call(scope);
        }, this);

        transition.in();
    }

    fadeTransitionWhite(a, b, scope) {
        scope = scope || window;

        const transition = new P3.FadeTransition(0xffffff);
        common.transitions.addChild(transition);

        transition.signals.in.add(function () {
            transition.out();
            a && a.call(scope);
        }, this);

        transition.signals.out.add(function () {
            transition.destroy();
            b && b.call(scope);
        }, this);

        transition.in();
    }

    // lazy unloading, flags all textures to be unloaded if they aren't being used
    flagAllTexturesForUnloading() {
        const resources = P3.assets._resources;
        for (let key in resources) {
            if (resources.hasOwnProperty(key)) {
                const r = resources[key];
                if (r.textures) {
                    // use first texture in sprite sheet to grab base texture, dispose of that to free up memory if its not needed
                    let t;
                    for (let k in r.textures) {
                        if (r.textures.hasOwnProperty(k)) {
                            t = r.textures[k];
                            break;
                        }
                    }
                    t && t.baseTexture.dispose();
                } else if (r.texture) {
                    // if its a bg jpeg dispose of that base texture too
                    r.texture.baseTexture.dispose();
                }
            }
        }
    }
}